var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwilio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fill: "#f12e45",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.028 37.272H99.4c-.128 0-.256.128-.256.256v3.264c0 .128.128.256.256.256h5.638c.128 0 .256-.128.256-.256v-3.264c.064-.128-.064-.256-.256-.256zm-.064 4.864H94.072a.53.53 0 0 0-.384.256l-1.474 5.568-1.666-5.696c-.064-.128-.192-.256-.384-.256h-4.23a.53.53 0 0 0-.384.256l-1.602 5.312-.064.256-.064-.128-.64-2.624-.705-2.624c-.064-.128-.192-.256-.384-.256H73.57v-4.608c0-.128-.192-.32-.384-.256L67.802 39c-.192.064-.256.128-.256.256v2.88h-1.4c-.128 0-.256.128-.256.256v4.096c0 .128.128.256.256.256h1.4v4.992c0 3.52 1.922 5.184 5.446 5.184 1.474 0 2.883-.32 3.844-.832v-4.224c0-.192-.192-.256-.32-.256-.577.256-1.025.32-1.538.32-.96 0-1.474-.384-1.474-1.472v-3.648h3.075c.128 0 .256-.128.256-.256v-3.456l4.037 13.376c.064.128.192.256.384.256h4.485a.53.53 0 0 0 .384-.256l1.922-5.952.96 3.072.897 2.816c.064.128.192.256.384.256h4.485a.53.53 0 0 0 .384-.256l4.1-13.44v13.44c0 .128.128.256.256.256h5.446c.128 0 .256-.128.256-.256V42.456c0-.192-.128-.32-.256-.32zm7.176-4.864h-5.446c-.128 0-.256.128-.256.256v18.88c0 .128.128.256.256.256h5.446c.128 0 .256-.128.256-.256v-18.88c0-.128-.128-.256-.256-.256zm7.24 0h-5.638c-.128 0-.256.128-.256.256v3.264c0 .128.128.256.256.256h5.638c.128 0 .256-.128.256-.256v-3.264c.064-.128-.064-.256-.256-.256zm-.064 4.864h-5.446c-.128 0-.256.128-.256.256v14.016c0 .128.128.256.256.256h5.446c.128 0 .256-.128.256-.256V42.456c0-.192-.128-.32-.256-.32zm9.034-.32c-4.805 0-8.2 3.52-8.2 7.616v.064c0 4.096 3.396 7.552 8.137 7.552 4.805 0 8.2-3.52 8.2-7.616v-.064c0-4.096-3.396-7.552-8.137-7.552zm2.307 7.616c0 1.408-.96 2.496-2.307 2.496s-2.37-1.152-2.37-2.56v-.064c0-1.408.96-2.496 2.307-2.496s2.37 1.152 2.37 2.624zM46.018 31C37.176 31 30 38.168 30 47s7.176 16 16.018 16 16.018-7.168 16.018-16-7.176-16-16.018-16zm0 27.776c-6.535 0-11.79-5.248-11.79-11.776s5.254-11.776 11.79-11.776S57.807 40.472 57.807 47s-5.254 11.776-11.79 11.776z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.99,
    cy: 43.032,
    rx: 3.332,
    ry: 3.328
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.99,
    cy: 50.968,
    rx: 3.332,
    ry: 3.328
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.046,
    cy: 50.968,
    rx: 3.332,
    ry: 3.328
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.046,
    cy: 43.032,
    rx: 3.332,
    ry: 3.328
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwilio);
export default __webpack_public_path__ + "static/media/twilio.10e91173bc78939b2df0989cdf009d74.svg";
export { ForwardRef as ReactComponent };